export const AUTH_TOKEN = "sdm_auth_token";
export const AUTH_PROFILE = "sdm_auth_profile";
